module.exports = __webpack_public_path__ + "img/menu-3.493d59d2.png";